import { DateFactory } from 'rhg-vue-common'

export default {
  setCurrentCustomer(state, user) {
    state.currentCustomer = { ...user }
  },
  labelsLoaded(state, labelsLoaded) {
    state.labelsLoaded = labelsLoaded
  },
  offset(state, offset) {
    state.offset = offset
  },
  countries(state, countries) {
    state.countries = Object.freeze(countries)
  },
  landingType(state, newLanding) {
    state.landingType = newLanding
  },
  brands(state, brands) {
    state.brands = brands
  },
  hotelTypes(state, hotelTypes) {
    state.hotelTypes = hotelTypes
  },
  tripAdvisorRating(state, ratings) {
    state.tripAdvisorRating = ratings
  },
  offers(state, offers) {
    state.offers = offers.map(offer => {
      offer.bookingStartDate = DateFactory.dateObject(offer.bookingStartDate).toDate()
      offer.bookingEndDate = DateFactory.dateObject(offer.bookingEndDate).toDate()
      return offer
    })
  },
  isOnlyRewards(state, isOnlyRewards) {
    state.isOnlyRewards = isOnlyRewards
  },
  selectBrand(state, brand) {
    state.brands = state.brands.map(b => (b.code === brand.code ? { ...brand, selected: true } : b))
    state.selectedBrands.push(brand)
  },
  unSelectBrand(state, brand) {
    state.brands = state.brands.map(b =>
      b.code === brand.code ? { ...brand, selected: false } : b
    )
    state.selectedBrands = state.selectedBrands.filter(x => x.code !== brand.code)
  },
  selectHotelType(state, hotelType) {
    state.hotelTypes = state.hotelTypes.map(t =>
      t.code === hotelType.code ? { ...hotelType, selected: true } : t
    )
    state.selectedHotelTypes.push(hotelType)
  },
  unSelectHotelType(state, hotelType) {
    state.hotelTypes = state.hotelTypes.map(t =>
      t.code === hotelType.code ? { ...hotelType, selected: false } : t
    )
    state.selectedHotelTypes = state.selectedHotelTypes.filter(x => x.code !== hotelType.code)
  },
  addHotels(state, hotels) {
    state.hotels = Object.freeze([...state.hotels, ...hotels])
  },
  selectedBrands(state, selectedBrands) {
    state.brands = state.brands.map(brand =>
      selectedBrands.filter(selectedBrand => selectedBrand.code === brand.code) > 0
        ? { ...brand, selected: true }
        : { ...brand, selected: false }
    )
    state.selectedBrands = [].concat(selectedBrands)
  },
  selectedHotelTypes(state, selectedHotelTypes) {
    state.hotelTypes = state.hotelTypes.map(hoteType =>
      selectedHotelTypes.filter(selectedHotelType => selectedHotelType.code === hoteType.code) > 0
        ? { ...hoteType, selected: true }
        : { ...hoteType, selected: false }
    )
    state.selectedHotelTypes = [].concat(selectedHotelTypes)
  },
  selectedOfferCountry(state, selectedOfferCountry) {
    state.selectedOfferCountry = selectedOfferCountry
  },
  selectedOfferCity(state, selectedOfferCity) {
    state.selectedOfferCity = selectedOfferCity
  },
  checkInDate(state, checkInDate) {
    state.checkInDate = checkInDate
  },
  checkOutDate(state, checkOutDate) {
    state.checkOutDate = checkOutDate
  },
  setFilterTypeAndContent(state, filter) {
    state.lastFilter = { ...filter }
  },
  center(state, center) {
    state.center = center
  },
  zoom(state, zoom) {
    state.zoom = zoom
  },
  loading(state) {
    state.loading += 1
  },
  free(state) {
    state.loading -= 1
  },
  focus(state, element) {
    state.focus = element
  },
  directoryHotels(state, hotels) {
    state.directory.hotels = hotels
  },
  directoryCountries(state, countries) {
    state.directory.countries = countries
  },
  directoryStates(state, states) {
    state.directory.states = states
  },
  directoryCities(state, cities) {
    state.directory.cities = cities
  },
  directorySelectedCountry(state, country) {
    state.directory.selectedCountry = country
  },
  directorySelectedState(state, _state) {
    state.directory.selectedState = _state
  },
  directorySelectedCity(state, city) {
    state.directory.selectedCity = city
  },
  directoryFilterPoints(state, points) {
    state.directory.points = points
  },
  directoryPagination(state, pagination) {
    state.directory.pagination = { ...state.directory.pagination, ...pagination }
  },
  fromPrice(state, price) {
    state.fromPrice = price
  },
  loadingPrice(state, isLoading) {
    state.loadingPrice = isLoading
  },
  customerProfile(state, customerProfile) {
    // eslint-disable-next-line
    console.log('mutations.customerProfile', customerProfile)
    state.customerProfile = customerProfile
  },
  setCustomerSummary(state, customerSummary) {
    state.customerSummary = customerSummary
  },
  loadingCustomer(state, loadingCustomer) {
    state.loadingCustomer = loadingCustomer
  },
  preferences(state, preferences) {
    state.preferences = preferences
  },
  loadingPreferences(state, loadingPreferences) {
    state.loadingPreferences = loadingPreferences
  },
  loadingNewsletter(state, loadingNewsletter) {
    state.loadingNewsletter = loadingNewsletter
  },
  currentFavHotel(state, currentFavHotel) {
    state.currentFavHotel = currentFavHotel
  },
  setCoBrandsImages(state, data) {
    state.coBrandImages = data
  },
  showTransliteratedField(state, data) {
    state.showTransliteratedField = data
  },
  updateTransliterableLanguagesLoaded(state, data) {
    state.transliterableLanguagesLoaded = data
  },
  isFormEdited(state, data) {
    state.isFormEdited = data
  },
  currentModalId(state, modalId) {
    state.currentModalId = modalId
  },
  changeDiscarded(state, data) {
    state.isChangeDiscarded = data
  },
  changeReservationsMemberType(state, memberType) {
    state.reservations = {
      groupType: state.reservations.groupType,
      memberType: memberType,
      filters: state.reservations.filters,
      page: 0,
      total: 0,
      allReservations: [],
      clientPage: 0,
      smartLinkingLoaded: false,
      reservations: []
    }
    state.reservationsWithExploreHotel = []
  },
  changeReservationsGroupType(state, groupType) {
    state.reservations = {
      groupType: groupType,
      memberType: state.reservations.memberType,
      filters: state.reservations.filters,
      page: 0,
      total: 0,
      allReservations: [],
      clientPage: 0,
      smartLinkingLoaded: false,
      reservations: [],
      B2BBusinessReservations: state.reservations.B2BBusinessReservations,
      B2BPersonalReservations: state.reservations.B2BPersonalReservations
    }
    state.reservationsWithExploreHotel = []
  },
  setReservationsFilters(state, filters) {
    state.reservations = {
      filters,
      groupType: state.reservations.groupType,
      memberType: state.reservations.memberType,
      page: 0,
      total: 0,
      allReservations: [],
      clientPage: 0,
      smartLinkingLoaded: false,
      reservations: []
    }
  },
  fetchingReservations(state) {
    state.reservations.loading = true
  },
  setSmartLinkingReservations(state, data) {
    state.reservations.allReservations = data.reservations
    state.reservations.clientPage = data.clientPage
    state.reservations.smartLinkingLoaded = true
  },
  fetchingTransactions(state) {
    state.transactions.loading = true
  },
  fetchedReservations(state, data) {
    if (data.groupType === state.reservations.groupType) {
      state.reservations = {
        loading: false,

        allReservations: state.reservations.allReservations,
        clientPage: state.reservations.clientPage,
        smartLinkingLoaded: state.reservations.smartLinkingLoaded,
        page: parseInt(data.page),
        total: data.count,
        memberType: state.reservations.memberType,
        groupType: state.reservations.groupType,
        filters: state.reservations.filters,
        reservations: data.hasPagination
          ? [...state.reservations.reservations, ...data.reservations]
          : [...data.reservations],
        B2BBusinessReservations: state.reservations.B2BBusinessReservations,
        B2BPersonalReservations: state.reservations.B2BPersonalReservations
      }
    }
  },
  fetchedTransactions(state, data) {
    state.transactions = {
      loading: false,
      page: parseInt(data.page),
      total: data.count,
      filters: state.transactions?.filters,
      filterApplied: data.filterApplied,
      transactions: data.hasPagination
        ? [...state.transactions.transactions, ...data.transactions]
        : [...data.transactions]
    }
  },
  fetchedB2BBusinessReservations(state, data) {
    if (data.groupType === state.reservations.groupType) {
      state.reservations = {
        loading: false,
        page: parseInt(data.page),
        total: data.count,
        memberType: data.memberType,
        groupType: state.reservations.groupType,
        filters: state.reservations.filters,
        reservations: state.reservations.reservations,
        B2BBusinessReservations: {
          memberType: data.memberType,
          reservationsList: [...data.reservations]
        },
        B2BPersonalReservations: state.reservations.B2BPersonalReservations
      }
    }
  },
  fetchedB2BPersonalReservations(state, data) {
    if (data.groupType === state.reservations.groupType) {
      state.reservations = {
        loading: false,
        page: parseInt(data.page),
        total: data.count,
        memberType: data.memberType,
        groupType: state.reservations.groupType,
        filters: state.reservations.filters,
        reservations: state.reservations.reservations,
        B2BBusinessReservations: state.reservations.B2BBusinessReservations,
        B2BPersonalReservations: {
          memberType: data.memberType,
          reservationsList: [...data.reservations]
        }
      }
    }
  },
  setReservationsWithExploreHotel(state, data) {
    state.reservationsWithExploreHotel = [...state.reservationsWithExploreHotel, ...data]
    state.reservations.reservations = state.reservations.reservations.map(r => {
      const newReservation = state.reservationsWithExploreHotel.find(
        n => n.bookingId === r.bookingId && n.occupancy === r.occupancy
      )
      if (newReservation) return newReservation
      return r
    })
  },
  setInviteMember(state, inviteMember) {
    state.inviteMember = inviteMember
  },
  setNoReservationsData(state, data) {
    state.noReservations = data
  },
  setCurrentView(state, currentView) {
    state.currentView = currentView
  },
  setCurrentCustomerProfileCompletition(state, value) {
    state.currentCustomer.profileInfoCompletionPercentage = value
  },
  setTransactionsTypeFilter(state, value) {
    state.transactions.filters.type = value
  },
  setTransactionsCategoryFilter(state, value) {
    state.transactions.filters.filter = value
  },
  setTransactionsDateFilter(state, data) {
    state.transactions.filters.dateFrom = data.dateFrom
    state.transactions.filters.dateTo = data.dateTo
  },
  resetTransactionsState(state) {
    state.transactions.filterApplied = true
    state.transactions.page = 1
    state.transactions.transactions = []
  },
  resetTransactionsFilters(state) {
    state.transactions.filters.filter = ''
    state.transactions.filters.type = ''
    state.transactions.filters.dateFrom = ''
    state.transactions.filters.dateTo = ''
  },
  resetTransactionsCategoryFilters(state) {
    state.transactions.filters.filter = ''
  },
  resetTransactionsTypeFilters(state) {
    state.transactions.filters.type = ''
  },
  resetTransactionsDateFilters(state) {
    state.transactions.filters.dateFrom = ''
    state.transactions.filters.dateTo = ''
  },
  loadingInvoice(state, loadingInvoice) {
    state.loadingInvoice = loadingInvoice
  },
  loadingClaimPoints(state, loadingClaimPoints) {
    state.loadingClaimPoints = loadingClaimPoints
  },
  setAppleTreeBannerInfo(state, appleTreeBannerInfo) {
    state.appleTreeBannerInfo = appleTreeBannerInfo
  }
}
